document.addEventListener('DOMContentLoaded', function () {
  function addLabel(el, text) {
    if (!el) return;
    var prev = el.previousElementSibling;
    if (prev && prev.classList.contains('visually-hidden')) return;
    var label = document.createElement('span');
    label.className = 'visually-hidden';
    label.textContent = text;
    el.parentNode.insertBefore(label, el);
  }

  document.querySelectorAll('[id="product-price"]').forEach(function (priceBlock) {
    var salePriceEl = priceBlock.querySelector('.product-price');
    var wasPriceEl = priceBlock.querySelector('.was');

    if (wasPriceEl) {
      addLabel(salePriceEl, 'Sale Price');
      addLabel(wasPriceEl, 'Regular Price');
    } else if (salePriceEl) {
      addLabel(salePriceEl, 'Regular Price');
    }
  });

  function setItemFocusable(item, focusable) {
    var controls = item.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    controls.forEach(function (el) {
      if (focusable) {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', '-1');
      }
    });
    item.setAttribute('aria-hidden', focusable ? 'false' : 'true');
  }

  function setupCarouselNavButton(btn, label) {
    if (!btn || btn.dataset.a11ySetup) return;
    btn.dataset.a11ySetup = 'true';
    btn.setAttribute('role', 'button');
    btn.setAttribute('tabindex', '0');
    btn.setAttribute('aria-label', label);
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        btn.click();
      }
    });
  }

  function initCarouselAccessibility(carousel, viewport) {
    var items = carousel.querySelectorAll('.owl-item');
    if (!items.length || typeof IntersectionObserver === 'undefined') return;

    items.forEach(function (item) {
      setItemFocusable(item, false);
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setItemFocusable(entry.target, entry.intersectionRatio >= 0.5);
      });
    }, { root: viewport, threshold: [0, 0.5, 1] });

    items.forEach(function (item) {
      observer.observe(item);
    });
setupCarouselNavButton(
  carousel.querySelector('.owl-prev, .flex-prev'),
  'Previous slide'
);


setupCarouselNavButton(
  carousel.querySelector('.owl-next, .flex-next'),
  'Next slide'
);
  }

  function whenCarouselReady(carousel, callback) {
    var viewport = carousel.querySelector('.owl-wrapper-outer');
    if (viewport) {
      callback(viewport);
      return;
    }
    var mo = new MutationObserver(function () {
      var vp = carousel.querySelector('.owl-wrapper-outer');
      if (vp) {
        mo.disconnect();
        callback(vp);
      }
    });
    mo.observe(carousel, { childList: true, subtree: true });
  }

  document.querySelectorAll('.owl-carousel').forEach(function (carousel) {
    whenCarouselReady(carousel, function (viewport) {
      initCarouselAccessibility(carousel, viewport);
    });
  });

  function markSlickListItem(slide) {
    slide.setAttribute('role', 'listitem');
  }

  function markSlickList(track) {
    track.setAttribute('role', 'list');
    track.querySelectorAll(':scope > .slick-slide').forEach(markSlickListItem);
  }

  document.querySelectorAll('.slick-track').forEach(markSlickList);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList.contains('slick-track')) markSlickList(node);
        if (node.classList.contains('slick-slide')) markSlickListItem(node);
        node.querySelectorAll && node.querySelectorAll('.slick-track').forEach(markSlickList);
        node.querySelectorAll && node.querySelectorAll('.slick-slide').forEach(markSlickListItem);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  function fixThumbSlide(slide) {
    if (slide.getAttribute('aria-hidden') === 'true') {
      slide.setAttribute('aria-hidden', 'false');
    }
    if (slide.getAttribute('tabindex') === '-1') {
      slide.removeAttribute('tabindex');
    }
    slide.querySelectorAll('[tabindex="-1"]').forEach(function (el) {
      el.removeAttribute('tabindex');
    });
  }

  function keepThumbGalleryAccessible(gallery) {
    gallery.querySelectorAll('.slick-slide').forEach(fixThumbSlide);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var slide = mutation.target.closest && mutation.target.closest('.slick-slide');
        if (slide) fixThumbSlide(slide);
      });
    }).observe(gallery, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'tabindex'],
      subtree: true
    });
  }

  document.querySelectorAll('.product-thumb-gallery').forEach(keepThumbGalleryAccessible);

  function fixQuickViewLink(link) {
    if (link.dataset.a11yQuickView) return;
    link.dataset.a11yQuickView = 'true';
    link.setAttribute('role', 'button');
    link.setAttribute('aria-haspopup', 'true');
    if (!link.getAttribute('aria-label')) {
      link.setAttribute('aria-label', link.textContent.trim() || 'Quick View');
    }
  }

  document.querySelectorAll('.product-modal').forEach(fixQuickViewLink);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList.contains('product-modal')) fixQuickViewLink(node);
        node.querySelectorAll && node.querySelectorAll('.product-modal').forEach(fixQuickViewLink);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  if (typeof jQuery === 'undefined' || !jQuery.fancybox) return;
  var $ = jQuery;
  var lastTrigger = null;
  var trapHandler = null;

  function getFocusable(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  $(document).on('afterShow', function () {
    var current = $.fancybox.current;
    lastTrigger = (current && current.element && current.element[0]) || document.activeElement;

    var wrap = $.fancybox.wrap;
    if (!wrap || !wrap.length) return;
    var wrapEl = wrap[0];

    wrapEl.setAttribute('role', 'dialog');
    wrapEl.setAttribute('aria-modal', 'true');

    var closeBtn = wrapEl.querySelector('.fancybox-close');
    if (closeBtn) {
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.setAttribute('role', 'button');
      var skin = wrapEl.querySelector('.fancybox-skin');
      if (skin && skin.firstChild !== closeBtn) {
        skin.insertBefore(closeBtn, skin.firstChild);
      }
      closeBtn.focus();
    }

    trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      var focusable = getFocusable(wrapEl);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!wrapEl.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', trapHandler, true);
  });

  $(document).on('afterClose', function () {
    if (trapHandler) {
      document.removeEventListener('keydown', trapHandler, true);
      trapHandler = null;
    }
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  });
});


// external link warning////
$(document).ready(function () {
  const currentHost = window.location.hostname.replace("www.", "");
  const warningText =
    " Redirecting to a third-party website (opens in a new tab).";
 
  $('a[href^="http://"], a[href^="https://"]').each(function () {
    const $link = $(this);
    const linkHost = this.hostname.replace("www.", "");
 
    if (linkHost === currentHost || !linkHost) return;
 
    let linkText = $link.text().trim();
    if (!linkText) {
      const imgAlt = $link.find("img").attr("alt");
      linkText = imgAlt ? imgAlt.trim() : "this link";
    }
 
    const currentAriaLabel = $link.attr("aria-label");
    const newLabel = currentAriaLabel
      ? `${currentAriaLabel}${warningText}`
      : `${linkText}${warningText}`;
 
    $link.attr({
      "aria-label": newLabel,
      title: newLabel,
      target: "_blank",
      rel: "noopener noreferrer nofollow",
    });
 
    $link.addClass("external-link");
  });
});




//  JavaScript for Toggle Functionality


const toggleBtn = document.getElementById("toggleBtn");
const dropdown = document.getElementById("dropdown");

toggleBtn.addEventListener("click", function () {
    const isExpanded = toggleBtn.getAttribute("aria-expanded") === "true";

    toggleBtn.setAttribute("aria-expanded", String(!isExpanded));
    dropdown.hidden = isExpanded;
});


